import React from 'react';
import { Section } from './Section';
import { Sparkles } from 'lucide-react';
export const Mecanismo = () => {
  return <Section className="relative overflow-hidden" data-id="element-141">
      {/* Sacred geometry background hint */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-gold/5 rounded-full pointer-events-none" data-id="element-142" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-gold/5 rounded-full pointer-events-none" data-id="element-143" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-gold/10 rounded-full pointer-events-none" data-id="element-144" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-145">
        <div className="text-center mb-12" data-id="element-146">
          <div className="inline-flex items-center justify-center p-3 rounded-full bg-gold/10 text-gold mb-6" data-id="element-147">
            <Sparkles size={28} data-id="element-148" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-149">
            La solución no es renunciar, es aplicar el{' '}
            <span className="text-gold" data-id="element-150">Desacople Cuántico</span>
          </h2>
        </div>

        <div className="p-8 md:p-10 border border-gold/30 bg-navy-900/80 backdrop-blur-md rounded-sm shadow-[0_0_40px_rgba(201,169,97,0.05)]" data-id="element-151">
          <p className="text-lg md:text-xl text-gray-200 font-light leading-relaxed mb-6 text-center" data-id="element-152">
            Este botiquín te enseña a crear una{' '}
            <strong className="text-gold font-medium" data-id="element-153">
              membrana de protección invisible
            </strong>{' '}
            que permite que tu trabajo salga, pero que la toxicidad rebote.
          </p>
          <div className="h-px w-full bg-gradient-to-r from-transparent via-gold/30 to-transparent my-8" data-id="element-154" />
          <p className="text-center text-gray-300 italic font-serif text-xl" data-id="element-155">
            "Son protocolos de 30 segundos que podés hacer en el baño, en el
            ascensor o frente a tu compu, sin que nadie se dé cuenta de que
            estás blindada."
          </p>
        </div>
      </div>
    </Section>;
};